import type { ScenarioOrder } from '../../../lib/planningData';
import type { TimeData } from '../../core/TimeData';
import { isLoadEventTimeData } from '../../core/TimeData';
import { calculateFreightAmount } from '../../../lib/freightCalculation';

/**
 * Calculate freight costs for relet shipments using data already available in the timeline.
 */
export function calculateTimelineFreightCosts(
  events: TimeData[],
  orders: ScenarioOrder[],
): number {
  let totalFreightCost = 0;

  orders.forEach((order) => {
    const outgoingVC = order.outgoingVoyageCharterRelation;
    if (outgoingVC?.voyageCharterByVoyageCharterId) {
      const voyageCharter = outgoingVC.voyageCharterByVoyageCharterId;

      if (voyageCharter.lumpsum) {
        const lumpsumAmount = Number(voyageCharter.lumpsum);
        if (!isNaN(lumpsumAmount)) {
          totalFreightCost += lumpsumAmount;
        }
      }

      // Add calculated freight from voyage charter order freights
      const orderFreights =
        outgoingVC.voyageCharterOrderFreightsByOrderVoyageCharterRelationId
          ?.nodes;
      if (orderFreights) {
        orderFreights.forEach((freight) => {
          if (freight?.freightAmount) {
            const freightRate = Number(freight.freightAmount);
            if (!isNaN(freightRate)) {
              // Get cargo volume/mass from the load event for this order
              const loadEvent = events.find(
                (event) =>
                  isLoadEventTimeData(event) &&
                  event.event.order?.id === order.id,
              );

              if (loadEvent && freight.freightUnit) {
                const freightAmount = calculateFreightAmount({
                  mass: loadEvent.mass,
                  volume: loadEvent.volume,
                  pcs: loadEvent.pcs,
                  freightRate,
                  freightUnit: freight.freightUnit,
                  order,
                });

                if (freightAmount !== null) {
                  totalFreightCost += freightAmount;
                }
              }
            }
          }
        });
      }
    }
  });

  return totalFreightCost;
}
